import React, { useEffect, useState, useMemo } from "react";
import { useGlobalStore } from "@/store/hooks";
import { useHistory } from "react-router";
import OrderTab from "../enum/OrderTab";
import useMountedState from "@/hooks/useMountedState";
import { TbGroupShopTypes } from "@/utils/ShopUtils";
import ShopType from "@/enum/ShopType";

// 1 非淘系账户登录，鼠标悬浮在淘宝店铺上时，提示文案：应淘宝安全要求，需用淘宝账户登录才可以查看淘宝订单，点击会跳转淘宝登录

// 2 非淘系账户登录，点击淘宝店铺，已登录淘宝账号则会使用淘宝账号登录，没有登录淘宝账号则会当前页面跳转登录页面

const useProcessingShop = (rawShopId: number) => {
    const { allowedShops: shops, currentUser, shopMapping } = useGlobalStore();

    const [redirectShopId, updateRedirectShopId] = useState(false);

    const history = useHistory();

    const getMounted = useMountedState();

    const isTBUser = useMemo(() => {
        const currentUserShopType = shopMapping.get(currentUser?.shopId)?.type;

        return TbGroupShopTypes.includes(currentUserShopType);
    }, [shopMapping, currentUser]);

    /** 重定向 */
    useEffect(() => {
        if (redirectShopId) {
            history.push(`/order/list?shopId=${redirectShopId}&tab=${OrderTab.PENDING_SHIPMENT}`);
        }
    }, [redirectShopId]);

    function isOtherPlatform(id) {
        const shop = shopMapping.get(id);

        const shopType = shop?.type;

        if (shopType !== ShopType.TAOBAO && shopType !== ShopType.TAOBAO_DISTRIBUTION) {
            // 直接在浏览器中输入店铺的Id 如果不符合规则 需要重定向
            // eg:PDD用户登录 链接中输入TB店铺的Id
            if (rawShopId && id !== rawShopId) {
                updateRedirectShopId(id);
            }

            return true;
        }

        return false;
    }

    const shopId = useMemo(() => {
        const mounted = getMounted();

        if (isTBUser) {
            // 当非淘宝的其他平台排第一的时候，进入千牛发货易小程序会报错，添加默认shopId逻辑跳到淘宝的店铺中
            const defaultShopId = import.meta.env.VITE_IS_QN && !mounted ? currentUser.shopId : shops[0].id;

            return rawShopId || defaultShopId;
        } else {
            const allShopIds = shops.map(({ id }) => id);

            if (rawShopId) {
                const isOther = isOtherPlatform(rawShopId);

                if (isOther) {
                    return rawShopId;
                }
            }

            for (const indeterminateShopId of allShopIds) {
                const isOther = isOtherPlatform(indeterminateShopId);

                if (isOther) {
                    return indeterminateShopId;
                }
            }
        }
    }, [isTBUser, rawShopId]);

    return { shopId, shops };
};

export default useProcessingShop;
